// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__13wUV","inputWrap":"CustomTip_inputWrap__2oPOh"};